export const eightColors = [
  "#2F4B7C",
  "#F99059",
  "#496D91",
  "#E75955",
  "#6790A2",
  "#93003A",
  "#BFE1C6",
  "#C5254A",
];

export const tenColors = [
  "#2F4B7C",
  "#FA9B58",
  "#44668D",
  "#BC1B48",
  "#769EA7",
  "#F06F57",
  "#5B829C",
  "#93003A",
  "#BFE1C6",
  "#DB4451",
];

export const fourteenColors = [
  "#2F4B7C",
  "#FBA858",
  "#88AFAB",
  "#CB2D4C",
  "#3E5E88",
  "#F78858",
  "#719AA6",
  "#B11044",
  "#4D7294",
  "#EE6857",
  "#5E869E",
  "#93003A",
  "#93003A",
  "#DF4A53",
];

export const eighteenColors = [
  "#2F4B7C",
  "#FA9659",
  "#BFE1C6",
  "#D2364F",
  "#AB0A42",
  "#6F98A0",
  "#3A5A86",
  "#93B8AC",
  "#FBAF57",
  "#527997",
  "#F57D58",
  "#46698F",
  "#EC6556",
  "#C02049",
  "#60889F",
  "#80A8AA",
  "#E14D53",
  "#93003A",
];

export const twentyFiveColors = [
  "#00429D",
  "#93C4D2",
  "#6492C0",
  "#B61A49",
  "#E37B7E",
  "#FBAF57",
  "#73A2C6",
  "#FA9659",
  "#4771B2",
  "#DF6772",
  "#A5D5D8",
  "#3761AB",
  "#D0CCB6",
  "#D95367",
  "#DAB8A7",
  "#D3F4E0",
  "#E38F8B",
  "#2451A4",
  "#5681B9",
  "#A60841",
  "#BFE1C6",
  "#C42D52",
  "#82B3CD",
  "#F57D58",
  "#93003A",
];
